
export default class NearestNeighborProcessor {

  /**
   * @param referenceData
   * @param nearestNeighbours
   * @param currentSiteId
   * @return array data
   */
  process(referenceData, nearestNeighbours, currentSiteId) {
    let nearestNeighbour = nearestNeighbours[0];
    if (nearestNeighbour !== null && nearestNeighbour.siteId !== null) {
      let nearestNeighbourId = nearestNeighbour.siteId;
      let neighbourRow = referenceData[nearestNeighbourId];
      return neighbourRow.data;
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/algorithm-processor/nearest-neighbor-processor.js